import axiosInstance from "../../../services/api/axiosInstance";

const validId = id => Number.isSafeInteger(id) && id > 0;
const validAccount = account => account && validId(account.accountId) && validId(account.schoolId) &&
  typeof account.name === "string" && account.name.trim() &&
  typeof account.schoolName === "string" && account.schoolName.trim();

export async function getLinkedProfiles() {
  const response = await axiosInstance.get("/auth/linked-profiles", { sensitiveRequest: true });
  const payload = response.data;
  if (payload?.success !== true || !Array.isArray(payload.accounts) ||
    !payload.accounts.every(validAccount) ||
    new Set(payload.accounts.map(account => account.accountId)).size !== payload.accounts.length) {
    throw new Error("Linked profiles could not be verified. Please contact support.");
  }
  return payload.accounts;
}

export async function switchLinkedProfile(account) {
  if (!validAccount(account)) throw new Error("Select a valid linked student profile.");
  const response = await axiosInstance.post("/auth/switch-profile", { accountId: account.accountId }, { sensitiveRequest: true });
  const result = response.data;
  if (result?.success !== true || typeof result.token !== "string" || !result.token.trim() ||
    result.data?.accountId !== account.accountId || result.data?.schoolId !== account.schoolId ||
    result.data?.roles?.[0] !== "STUDENT" || !result.data?.username) {
    throw new Error("The selected student's session could not be verified. Your current profile has not changed.");
  }
  return result;
}
